<div class="container">
  <mat-card>
    <form [formGroup]="withdrawClientForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div fxLayout="column">
          <mat-form-field (click)="withdrawalDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Withdrawal Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="withdrawalDatePicker"
              required
              formControlName="withdrawalDate"
            />
            <mat-datepicker-toggle matSuffix [for]="withdrawalDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #withdrawalDatePicker></mat-datepicker>
            <mat-error *ngIf="withdrawClientForm.controls.withdrawalDate.hasError('required')">
              {{ 'labels.inputs.Withdrawal Date' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="48%">
            <mat-label>{{ 'labels.inputs.Withdrawal Reason' | translate }}</mat-label>
            <mat-select formControlName="withdrawalReasonId">
              <mat-option *ngFor="let reason of withdrawalData" [value]="reason.id">
                {{ reason.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="withdrawClientForm.controls.withdrawalReasonId.hasError('required')">
              {{ 'labels.inputs.Withdrawal Reason' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!withdrawClientForm.valid">
          {{ 'labels.buttons.Confirm' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
